import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const pages = ['Nosotros', 'Productos', 'Novedades','Contacto', 'Dejanos tu CV'];

function NavBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [changeNav, setChangeNav] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const goToSection = (event, sectionId) => {
    event.preventDefault();
    handleCloseNavMenu();
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      window.history.replaceState(null, '', `/#${sectionId}`);
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  React.useEffect(() => {
    const updateNavState = () => {
      setChangeNav((prev) => {
        const next = window.scrollY >= 200;
        return prev === next ? prev : next;
      });
    };

    updateNavState();

    window.addEventListener("scroll", updateNavState, { passive: true });
    return () => {
      window.removeEventListener("scroll", updateNavState);
    };

  }, []);

  return (
    <AppBar position="absolute"
      sx={{
        borderRadius: changeNav ? '0px' : '50px', top: changeNav ? 0 : 15, width: changeNav ? '100%' : '90%', margin: changeNav ? '0' : '0 5%', backgroundColor: '#2A4E9C', position: changeNav ? 'fixed' : 'absolute',
        transition: 'border-radius 0.3s ease, top 0.3s ease, width 0.3s ease, margin 0.3s ease',
      }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          <Box
            sx={{
              display: { xs: 'none', md: 'inline-block' },
              boxSizing: 'border-box',
              marginLeft: changeNav ? 0 : '-35px',
              width: changeNav ? '170px' : '90px',
              height: changeNav ? '80px' : '60px',
            }}>
            <Link to="/">
              <img src={changeNav ? '/assets/logos/logoblanco.png' : '/assets/logos/isologo.png'}
                alt="logo" style={{
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                }} />
            </Link>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu main"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon color='primary' fontSize='large' />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' }
              }}
            >
              {pages.map((page, index) => (
                <MenuItem key={page} onClick={index <= 3 ? (e) => goToSection(e, page) : handleCloseNavMenu} >
                  {index <= 3 ? (
                    <Typography textAlign="center">{page}</Typography>
                  ) : (
                    <Link to="/teamSertex" style={{ textDecoration: 'none', color: 'black' }}>
                      <Typography textAlign="center">{page}</Typography>
                    </Link>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              flexGrow: 0.5,
              boxSizing: 'border-box',
              marginRight: { xs: '-10px', md: '-30px' },
              width: '3%',
              height: '70px',
            }}>
            <Link to="/">
              <img src='/assets/logos/isologo.png' alt="Logo" style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              }} />
            </Link>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'end', }}>
            {pages.map((page, index) => (
              <Button
                key={page}
                component={index <= 3 ? 'button' : Link}
                to={index <= 3 ? undefined : '/teamSertex'}
                onClick={index <= 3 ? (e) => goToSection(e, page) : undefined}
                sx={{ my: 2, color: 'white', display: 'block', textDecoration: 'none', '&:hover': { backgroundColor: '#007aff', }, }}
              >
                {page}
              </Button>
            ))}
          </Box>


        </Toolbar>
      </Container>
    </AppBar >
  );
}
export default NavBar;
